export interface Project {
  title: string;
  link: string;
  category: string;
  image: string;
  description: string;
}

export const projects: Project[] = [
  {
    title: "Vyro",
    link: "https://www.vyro.co/",
    category: "SaaS",
    image: "Vyro.png",
    description:
      "Virtual electric car dealership simplifying the end-to-end purchase process for electric vehicles.",
  },
  {
    title: "Dazychain",
    link: "https://www.dazychain.com/",
    category: "Enterprise",
    image: "Dazychain.png",
    description:
      "Legal platform enabling internal teams to outsource, manage, and invoice legal matters.",
  },
  {
    title: "FOUR.IO",
    link: "https://info.four.io/",
    category: "Logistics",
    image: "FOUR.png",
    description:
      "Componentised platform solving supply chain and logistics challenges for enterprise clients.",
  },
  {
    title: "SA Museum",
    link: "https://www.samuseum.sa.gov.au/",
    category: "Public sector",
    image: "SA Museum.png",
    description:
      "Public-facing website for South Australia's largest collection of cultural and national history.",
  },
  {
    title: "Hendercare",
    link: "https://www.hendercare.com.au/",
    category: "Healthcare",
    image: "Hendercare.png",
    description:
      "Internal booking system supporting aged care and disability service operations.",
  },
];
